import styled, { css } from 'styled-components'

interface ContainerInterface {
  width?: string
  menuWidth?: string
  borderWidth?: string
  color?: string
  colorDisabled?: string
  borderColor?: string
  borderRadius?: string
  backgroundColor?: string
  border?: string
  borderFocus?: string
  outline?: string
  borderColorFocus?: string
  colorFocus?: string
  backgroundColorFocus?: string
  colorSelected?: string
  backgroundColorSelected?: string
  menuMarginTop?: string
  menuBorderWidth?: string
  valueContainerPadding?: string
  indicatorColorFocus?: string
  indicatorColorHover?: string
  position?: string
  fontSize?: string
}

export const Container = styled.div.attrs({
  className: 'authflow-select-input',
})<ContainerInterface>`
  display: inline-block;
  width: ${(props) => (props.width ? props.width : '100%')};
  position: ${(props) => (props.position ? props.position : 'relative')};
  ${({ position }) =>
    position === 'absolute' &&
    css`
      top: 1px;
      left: 1px;
      z-index: 1;
    `}

  font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};

  .select-input {
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;

    &__value-container {
      padding: ${(props) =>
        props.valueContainerPadding
          ? props.valueContainerPadding
          : '10px 14px'} !important;
    }

    &__single-value {
      color: ${(props) => (props.color ? props.color : 'hsl(0, 0%, 20%)')};

      &--is-disabled {
        color: ${(props) =>
          props.colorDisabled ? props.colorDisabled : 'pink'};
      }

      & > div {
        display: flex;
        align-items: center;
      }
    }

    &__input-container {
      color: ${(props) => (props.color ? props.color : '#000')};
    }

    &__control {
      border-width: ${(props) =>
        props.borderWidth ? props.borderWidth : '100%'};
      background-color: ${(props) =>
        props.backgroundColor ? props.backgroundColor : '#fff'};
      color: ${(props) => (props.color ? props.color : '#000')};
      border-radius: ${(props) =>
        props.borderRadius ? props.borderRadius : '8px'};
      border: ${(props) => (props.border ? props.border : '1px solid silver')};
      box-shadow: ${(props) => (props.border ? props.border : 'none')};
      min-height: auto !important;

      :not(&--is-focused) {
        box-shadow: none;
      }

      :hover {
        cursor: pointer;
        box-shadow: none;
        outline: none;
        border: ${(props) =>
          props.border ? props.border : '1px solid silver'};
      }

      &--is-focused {
        box-shadow: none;
        color: ${(props) => (props.colorFocus ? props.colorFocus : '#000')};
        border: ${(props) =>
          props.borderFocus
            ? `${props.borderFocus}`
            : '1px solid silver'} !important;
        outline: ${(props) =>
          props.outline ? `${props.outline}` : '2px solid orange'} !important;

        .select-input__indicator {
          color: ${(props) =>
            props.indicatorColorFocus
              ? `${props.indicatorColorFocus}`
              : 'hsl(0, 0%, 80%)'}!important;
        }

        .select-input__indicator-separator {
          background-color: ${(props) =>
            props.borderColorFocus
              ? `${props.borderColorFocus}`
              : 'hsl(0, 0%, 80%)'} !important;
        }
      }

      &--menu-is-open {
        z-index: 100;
        background-color: ${(props) =>
          props.backgroundColor ? props.backgroundColor : '#fff'};
        border-radius: ${(props) =>
          props.borderRadius
            ? `${props.borderRadius} ${props.borderRadius}`
            : '8px 8px'}
          0px 0px;
        border: ${(props) =>
          props.border ? props.border : '1px solid silver'};

        :hover {
          background-color: ${(props) =>
            props.backgroundColor ? props.backgroundColor : '#fff'};
          border: ${(props) =>
            props.border ? props.border : '1px solid silver'};
        }
      }
    }

    &__menu {
      width: ${(props) =>
        props.menuWidth ? `${props.menuWidth} !important` : '100%'};
      border-radius: 0px 0px
        ${(props) =>
          props.borderRadius
            ? `${props.borderRadius} ${props.borderRadius}`
            : '8px 8px'};
      border-color: ${(props) =>
        props.borderColorFocus ? props.borderColorFocus : '#000'};
      background-color: ${(props) =>
        props.backgroundColor ? props.backgroundColor : '#FFF'};

      ${({ menuMarginTop }) =>
        menuMarginTop &&
        css`
          margin-top: ${menuMarginTop};
        `}

      ${({ menuBorderWidth }) =>
        menuBorderWidth &&
        css`
          border-width: ${menuBorderWidth};
          border-style: solid;
          box-shadow: none;
        `}

        ${({ position }) =>
          position === 'absolute' &&
          css`
            left: -1px;
            z-index: 1;
          `}
    }

    &__menu-list {
      padding-top: 0px;
      padding-bottom: 0px;
      border-radius: 0px 0px
        ${(props) =>
          props.borderRadius
            ? `${props.borderRadius} ${props.borderRadius}`
            : '8px 8px'};
    }

    &__option {
      padding: 10px 16px;
      color: ${(props) => (props.color ? props.color : '#000')};
      cursor: pointer;

      &--is-focused,
      &:focus,
      &:active {
        background-color: ${(props) =>
          props.backgroundColorFocus
            ? props.backgroundColorFocus
            : 'pink'}!important;
        color: ${(props) =>
          props.colorFocus ? props.colorFocus : '#000'}!important;
      }

      &--is-selected {
        background-color: ${(props) =>
          props.backgroundColorSelected
            ? props.backgroundColorSelected
            : '#000'}!important;
        color: ${(props) =>
          props.colorSelected ? props.colorSelected : '#FFF'}!important;
      }
    }

    &__indicator {
      color: ${(props) =>
        props.borderColor ? props.borderColor : 'hsl(0, 0%, 80%)'};

      :hover {
        color: ${(props) =>
          props.indicatorColorHover
            ? props.indicatorColorHover
            : 'hsl(0, 0%, 80%)'};
      }
    }

    &__indicator-separator {
      background-color: ${(props) =>
        props.borderColor ? props.borderColor : 'hsl(0, 0%, 80%)'}!important;
      width: ${(props) => (props.borderWidth ? props.borderWidth : '100%')};
    }
  }
`
